var render = function render(){var _vm=this,_c=_vm._self._c;return (_vm.links.length)?_c('ul',{staticClass:"p-headerMobileLinks"},_vm._l((_vm.links),function(link,index){return _c('li',{key:index,staticClass:"p-headerMobileLinks__item"},[_c('app-link',{staticClass:"p-headerMobileLinks__link",attrs:{"to":link.to},domProps:{"textContent":_vm._s(link.label)}})],1)}),0):_vm._e()
}
var staticRenderFns = []

export { render, staticRenderFns }